/* eslint-disable @typescript-eslint/no-empty-function */
import React from "react"
import { ButtonRow } from "../../../designSystem/button/ButtonRow";
import { H2, H3 } from '../../../designSystem/typography/Heading';
import { ListRowWithChildren, ListRowSizeVariant, ListRowStyleVariant, ListRowBorderVariant } from "../../../designSystem/compositeComponents/ListRow";

import styled from "styled-components";
import { Flex } from "../../../designSystem/compositeComponents/FlexHelpers";
import { colors } from "../../../designSystem/colors/color";

export const ListRowOverview = (): JSX.Element => {

    return (
        <>
            <ButtonRow variant={"left-aligned"}>
                <H2>ListRow</H2>
            </ButtonRow>

            <Flex flexDirection="column" gap={16}>
            <RowHeader>Nesting sharp borders</RowHeader>
            <Flex flexDirection="column">
            <ListRowWithChildren 
                sizeVariant="fat" 
                styleVariant="normal" 
                borderVariant="sharp"
                expanded={true} 
                onCollapse={()=>{}}
                content={
                    <>
                        Sustainable yes plz drinking vinegar, scenester sartorial VHS tote bag next level gochujang chartreuse. Dreamcatcher pinterest bushwick seitan XOXO grailed heirloom occupy freegan meggings fashion axe master cleanse raclette flannel direct trade. Bespoke gatekeep vibecession cardigan blog succulents. Bushwick 90&APOSs ascot, hashtag messenger bag VHS ethical hell of tonx marfa typewriter vibecession tbh +1. Ugh fit sriracha pitchfork tacos marfa, skateboard PBR&B cray lyft truffaut small batch actually.
                    </>
                }
                childRows={
                        <ListRowWithChildren 
                            sizeVariant="medium" 
                            styleVariant="bright" 
                            borderVariant="sharp"
                            level={"level2"} 
                            expanded={true} 
                            onCollapse={()=>{}}
                            childRows={
                                <>
                                    <ListRowWithChildren 
                                        sizeVariant="slim" 
                                        styleVariant="neutral" 
                                        borderVariant="sharp"
                                        level={"level3"}
                                        content={
                                            <>
                                            Sustainable yes plz drinking vinegar, scenester sartorial VHS tote bag next level gochujang chartreuse. Dreamcatcher pinterest bushwick seitan XOXO grailed heirloom occupy freegan meggings fashion axe master cleanse raclette flannel direct trade. Bespoke gatekeep vibecession cardigan blog succulents. Bushwick 90&APOSs ascot, hashtag messenger bag VHS ethical hell of tonx marfa typewriter vibecession tbh +1. Ugh fit sriracha pitchfork tacos marfa, skateboard PBR&B cray lyft truffaut small batch actually.
                                            </>
                                        } />
                                    <ListRowWithChildren 
                                        sizeVariant="slim" 
                                        styleVariant="bright" 
                                        borderVariant="sharp"
                                        level={"level3"}
                                        content={<>
                                            Sustainable yes plz drinking vinegar, scenester sartorial VHS tote bag next level gochujang.
                                        </>} />
                                </>
                            }
                            content={
                                <>
                                    Sustainable yes plz drinking vinegar, scenester sartorial VHS tote bag next level gochujang chartreuse. Dreamcatcher pinterest bushwick seitan XOXO grailed heirloom occupy freegan meggings fashion axe master cleanse raclette flannel direct trade. Bespoke gatekeep vibecession cardigan blog succulents. Bushwick 90&APOSs ascot, hashtag messenger bag VHS ethical hell of tonx marfa typewriter vibecession tbh +1. Ugh fit sriracha pitchfork tacos marfa, skateboard PBR&B cray lyft truffaut small batch actually.
                                </>
                            } 
                        />
                } />
            </Flex>

            <Flex flexDirection="column">
            <ListRowWithChildren 
                stripColor={colors.listRow.normal.border} 
                sizeVariant="slim" 
                styleVariant="normal" 
                borderVariant="sharp"
                expanded={true} 
                onCollapse={()=>{}}
                content={
                    <>
                        Sustainable yes plz drinking vinegar, scenester sartorial VHS tote bag next level gochujang chartreuse. Dreamcatcher pinterest bushwick seitan XOXO grailed heirloom occupy freegan meggings fashion axe master cleanse raclette flannel direct trade. Bespoke gatekeep vibecession cardigan blog succulents. Bushwick 90&APOSs ascot, hashtag messenger bag VHS ethical hell of tonx marfa typewriter vibecession tbh +1. Ugh fit sriracha pitchfork tacos marfa, skateboard PBR&B cray lyft truffaut small batch actually.
                    </>
                }
                childRows={
                        <ListRowWithChildren 
                            stripColor={colors.listRow.bright.border} 
                            sizeVariant="slim" 
                            styleVariant="bright" 
                            borderVariant="sharp"
                            level={"level2"} 
                            expanded={true} 
                            onCollapse={()=>{}}
                            childRows={
                                <>
                                    <ListRowWithChildren 
                                        stripColor={colors.listRow.neutral.border} 
                                        sizeVariant="slim" 
                                        styleVariant="neutral" 
                                        borderVariant="sharp"
                                        level={"level3"}
                                        content={
                                            <>
                                            Sustainable yes plz drinking vinegar, scenester sartorial VHS tote bag next level gochujang chartreuse. Dreamcatcher pinterest bushwick seitan XOXO grailed heirloom occupy freegan meggings fashion axe master cleanse raclette flannel direct trade. Bespoke gatekeep vibecession cardigan blog succulents. Bushwick 90&APOSs ascot, hashtag messenger bag VHS ethical hell of tonx marfa typewriter vibecession tbh +1. Ugh fit sriracha pitchfork tacos marfa, skateboard PBR&B cray lyft truffaut small batch actually.
                                            </>
                                        } />
                                    <ListRowWithChildren 
                                        stripColor={colors.listRow.bright.border} 
                                        sizeVariant="slim" 
                                        styleVariant="bright"
                                        borderVariant="sharp" 
                                        level={"level3"}
                                        content={<>
                                            Sustainable yes plz drinking vinegar, scenester sartorial VHS tote bag next level gochujang.
                                        </>} />
                                </>
                            }
                            content={
                                <>
                                    Sustainable yes plz drinking vinegar, scenester sartorial VHS tote bag next level gochujang chartreuse. Dreamcatcher pinterest bushwick seitan XOXO grailed heirloom occupy freegan meggings fashion axe master cleanse raclette flannel direct trade. Bespoke gatekeep vibecession cardigan blog succulents. Bushwick 90&APOSs ascot, hashtag messenger bag VHS ethical hell of tonx marfa typewriter vibecession tbh +1. Ugh fit sriracha pitchfork tacos marfa, skateboard PBR&B cray lyft truffaut small batch actually.
                                </>
                            } 
                        />
                } />
                </Flex>
            </Flex>


            <Flex flexDirection="column" gap={16}>
            <RowHeader>Nesting rounded borders</RowHeader>
            <Flex flexDirection="column">
            <ListRowWithChildren 
                stripColor={colors.listRow.normal.border} 
                sizeVariant="fat" 
                styleVariant="normal" 
                expanded={true} 
                onCollapse={()=>{}}
                content={
                    <>
                        Sustainable yes plz drinking vinegar, scenester sartorial VHS tote bag next level gochujang chartreuse. Dreamcatcher pinterest bushwick seitan XOXO grailed heirloom occupy freegan meggings fashion axe master cleanse raclette flannel direct trade. Bespoke gatekeep vibecession cardigan blog succulents. Bushwick 90&APOSs ascot, hashtag messenger bag VHS ethical hell of tonx marfa typewriter vibecession tbh +1. Ugh fit sriracha pitchfork tacos marfa, skateboard PBR&B cray lyft truffaut small batch actually.
                    </>
                }
                childRows={
                        <ListRowWithChildren stripColor={colors.listRow.bright.border} sizeVariant="medium" styleVariant="bright" level={"level2"} expanded={true} onCollapse={()=>{}}
                            childRows={
                                <>
                                    <ListRowWithChildren stripColor={colors.listRow.neutral.border} sizeVariant="slim" styleVariant="neutral" level={"level3"}
                                        content={
                                            <>
                                            Sustainable yes plz drinking vinegar, scenester sartorial VHS tote bag next level gochujang chartreuse. Dreamcatcher pinterest bushwick seitan XOXO grailed heirloom occupy freegan meggings fashion axe master cleanse raclette flannel direct trade. Bespoke gatekeep vibecession cardigan blog succulents. Bushwick 90&APOSs ascot, hashtag messenger bag VHS ethical hell of tonx marfa typewriter vibecession tbh +1. Ugh fit sriracha pitchfork tacos marfa, skateboard PBR&B cray lyft truffaut small batch actually.
                                            </>
                                        } />
                                    <ListRowWithChildren stripColor={colors.listRow.neutral.border} sizeVariant="slim" styleVariant="neutral" level={"level3"}
                                        content={<>
                                            Sustainable yes plz drinking vinegar, scenester sartorial VHS tote bag next level gochujang.
                                        </>} />
                                </>
                            }
                            content={
                                <>
                                    Sustainable yes plz drinking vinegar, scenester sartorial VHS tote bag next level gochujang chartreuse. Dreamcatcher pinterest bushwick seitan XOXO grailed heirloom occupy freegan meggings fashion axe master cleanse raclette flannel direct trade. Bespoke gatekeep vibecession cardigan blog succulents. Bushwick 90&APOSs ascot, hashtag messenger bag VHS ethical hell of tonx marfa typewriter vibecession tbh +1. Ugh fit sriracha pitchfork tacos marfa, skateboard PBR&B cray lyft truffaut small batch actually.
                                </>
                            } 
                        />
                } />
                </Flex>
            
            <Flex flexDirection="column" gap={10}>
            {['dark','bright','neutral'].map((styleVariant, i1) => {
                return ['rounded','sharp','none'].map((borderVariant, i2) => {
                    return ['fat','medium','slim'].map((sizeVariant, i3) => {
                        return [undefined, colors.listRow.normal.border].map((stripColor, i4) => {
                            return (
                                <ListRowWithChildren key={`${i1}-${i2}-${i3}-${i4}`} styleVariant={styleVariant as ListRowStyleVariant} sizeVariant={sizeVariant as ListRowSizeVariant} borderVariant={borderVariant as ListRowBorderVariant} stripColor={stripColor}
                                    content={
                                        <>
                                            <H3>
                                                {styleVariant} | {sizeVariant} | {borderVariant} | {stripColor || 'undefined'}
                                            </H3>
                                            <span>Sustainable yes plz drinking vinegar, scenester sartorial VHS tote bag next level gochujang chartreuse. Dreamcatcher pinterest bushwick seitan XOXO grailed heirloom occupy freegan meggings fashion axe master cleanse raclette flannel direct trade. Bespoke gatekeep vibecession cardigan blog succulents. Bushwick 90&APOSs ascot, hashtag messenger bag VHS ethical hell of tonx marfa typewriter vibecession tbh +1. Ugh fit sriracha pitchfork tacos marfa, skateboard PBR&B cray lyft truffaut small batch actually.</span>
                                        </>
                                    } />
                            );
                        });
                    });
                });
            })}
            </Flex>
            </Flex>

            
        </>
    )
}

const RowHeader = styled.h3`
    margin-top: 10px;
    margin-bottom: 5px;
`;